import { Add, KeyboardArrowRight } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';

import { SavedRouteAlert } from 'state/emailAlertsSlices';
import { SavedRoute } from 'state/savedRouteSlices';

import { AlertListItem } from './AlertListItem';

import styles from './AssignRoutesPage.module.css';

interface RouteAccordionProps {
  route: SavedRoute;
  alerts: SavedRouteAlert[];
  isExpanded: boolean;
  onExpand: (isExpanded: boolean) => void;
  onHover: (routeName: string | null) => void;
  onAddAlert: () => void;
}

export function RouteAccordion({
  route,
  alerts,
  isExpanded,
  onExpand,
  onHover,
  onAddAlert,
}: RouteAccordionProps) {
  const alertCount = alerts.length;
  const hasAlerts = alertCount > 0;

  return (
    <Accordion
      className={styles.routeAccordion}
      expanded={isExpanded}
      onChange={(_, newExpanded) => (hasAlerts ? onExpand(newExpanded) : null)}
    >
      <AccordionSummary
        expandIcon={<KeyboardArrowRight />}
        className={styles.accordionSummary}
        onMouseEnter={() => onHover(route.id)}
        onMouseLeave={() => onHover(null)}
        disabled={!hasAlerts}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Stack direction="row" gap={0.5} alignItems="center">
            <Typography variant="caption" className={styles.routeName}>
              {route.routeName}
            </Typography>
            {alertCount > 0 && (
              <Box className={styles.stepNumber}>{alertCount}</Box>
            )}
          </Stack>
          <Button
            variant="contained"
            startIcon={<Add />}
            className={styles.addAlertButton}
            onClick={(e) => {
              e.stopPropagation();
              onAddAlert();
            }}
          >
            <Typography variant="caption" className={styles.buttonText}>
              Add Alert
            </Typography>
          </Button>
        </Stack>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>
        <Stack spacing={1}>
          {alerts.map((alert) => (
            <AlertListItem
              className={styles.alertDetails}
              key={alert.hash_id}
              alert={alert}
              previewMode
            />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
